import { GET_COMPLAINTS_LIST } from '../../modules/constants';

export function getComplaintsList(value) {
  return {
    type: GET_COMPLAINTS_LIST,
    payload: value,
  };
}
